import { useQuery } from "@tanstack/react-query"
import { useAuth } from "hooks";
import { CustomerService } from "services";
import { Customer, CustomerFilterData } from "models";

export const useCustomers = () => {
    const { isAdministrator } = useAuth();
    const { data: customers, isFetching, error } = useQuery({
        queryKey: ['customers'],
        queryFn: isAdministrator ? CustomerService.getAll : CustomerService.getAllForUser
    })

    const filterFunction = (items: Customer[], filterData: CustomerFilterData) => {
        return items.filter((customer: Customer) => {
            if (filterData.email && !customer.email.toLowerCase().includes(filterData.email.toLowerCase())) {
                return false;
            }
            if (filterData.firstName && !customer.firstName.toLowerCase().includes(filterData.firstName.toLowerCase())) {
                return false;
            }
            if (filterData.lastName && !customer.lastName.toLowerCase().includes(filterData.lastName.toLowerCase())) {
                return false;
            }
            if (filterData.phoneNumber && !customer.phoneNumber.toLowerCase().includes(filterData.phoneNumber.toLowerCase())) {
                return false;
            }
            if (filterData.address && !customer.addressLine.toLowerCase().includes(filterData.address.toLowerCase())) {
                return false;
            }
            if (filterData.zipCode && !customer.zipCode.toLowerCase().includes(filterData.zipCode.toLowerCase())) {
                return false;
            }
            if (filterData.city && !customer.city.toLowerCase().includes(filterData.city.toLowerCase())) {
                return false;
            }
            if (filterData.country && !customer.country.toLowerCase().includes(filterData.country.toLowerCase())) {
                return false;
            }
            if (filterData.partnerId && customer.partnerId !== filterData.partnerId) {
                return false;
            }
            return true;
        });
    };
    return {
        customers,
        isFetching,
        error,
        filterFunction
    }
}